import React from 'react';
import { Helmet } from 'react-helmet-async';
import './MentionsLegalesPage.css';

const MentionsLegalesPage = () => {
  return (
    <>
      <Helmet>
        <title>Mentions légales - The Recap</title>
        <meta name="description" content="Mentions légales du site The Recap - the-recap.events" />
        <meta property="og:title" content="Mentions légales" />
        <meta property="og:type" content="website" />
      </Helmet>

      <section className="mentions-section">
        <div className="mentions-container fade-in">
          <h1 className="mentions-title">Mentions Légales</h1>
          <p className="mentions-date">En vigueur au 07/01/2025</p>

          <div className="mentions-content">
            <p>
              Conformément aux dispositions de la loi n°2004-575 du 21 juin 2004 pour la Confiance en l'économie numérique, il est porté à la connaissance des utilisateurs et visiteurs, ci-après l'<strong>« Utilisateur »</strong>, du site https://the-recap.events/, ci-après le <strong>« Site »</strong>, les présentes mentions légales.
            </p>
            <p>
              La connexion et la navigation sur le Site par l'Utilisateur implique acceptation intégrale et sans réserve des présentes mentions légales.
            </p>
            <p>
              Ces dernières sont accessibles sur le Site à la rubrique <strong>« Mentions légales »</strong>.
            </p>

            <h2>Édition du Site</h2>
            <p>
              L'édition et la direction de la publication du Site est assurée par Madame Laetitia Lamari, domiciliée 18 Rue Arago 94370 Sucy en Brie, dont le numéro de téléphone est 0619374187, et l'adresse e-mail laetitia@butterflyagency.io, ci-après l'<strong>« Éditeur »</strong>.
            </p>

            <h2>Hébergeur</h2>
            <p>
              L'hébergeur du Site est la société Webflow, Inc, dont le siège social est situé au 398 11th Street 94103 San Francisco.
            </p>

            <h2>Accès au Site</h2>
            <p>
              Le Site est normalement accessible, à tout moment, à l'Utilisateur. Toutefois, l'Éditeur pourra, à tout moment, suspendre, limiter ou interrompre le Site afin de procéder, notamment, à des mises à jour ou des modifications de son contenu. L'Éditeur ne pourra en aucun cas être tenu responsable des conséquences éventuelles de cette indisponibilité sur les activités de l'Utilisateur.
            </p>

            <h2>Collecte des Données</h2>
            <p>
              Le Site assure à l'Utilisateur une collecte et un traitement des données personnelles dans le respect de la vie privée conformément à la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés et dans le respect de la réglementation applicable en matière de traitement des données à caractère personnel conformément au règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 (ci-après, ensemble, la <strong>« Réglementation applicable en matière de protection des Données à caractère personnel »</strong>).
            </p>
            <p>
              En vertu de la Réglementation applicable en matière de protection des Données à caractère personnel, l'Utilisateur dispose d'un droit d'accès, de rectification, de suppression et d'opposition de ses données personnelles. L'Utilisateur peut exercer ce droit :
            </p>
            <p>
              - par mail à l'adresse email <a href="mailto:hello@the-recap.events">hello@the-recap.events</a>
            </p>
            <p>
              Toute utilisation, reproduction, diffusion, commercialisation, modification de toute ou partie du Site, sans autorisation expresse de l'Éditeur est prohibée et pourra entraîner des actions et poursuites judiciaires telles que prévues par la réglementation en vigueur.
            </p>
            <p>
              Pour plus d'informations, se reporter aux CGU du site <a href="https://the-recap.events/">https://the-recap.events/</a> accessibles depuis la rubrique « CGU ».
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default MentionsLegalesPage;
